import { useState } from "react";

import { useHistory } from "react-router";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Button, Menu, MenuItem, Tooltip } from "@mui/material";

import { useAuthContext } from "../../../../Context/AuthContext";
import { useUserContext } from "../../../../Context/UserContext";
import { type AnalyticsResources } from "../../analyticsResources/types";
import { type LabelWithRef } from "../types";
import AssignLabelsButton from "./AssignLabelsButton";

type Props = {
  labels: LabelWithRef[];
  selectedResources: AnalyticsResources[];
  disabled?: boolean;
};

export function EditLabelsMenuButton({ labels, selectedResources, disabled = false }: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const history = useHistory();
  const { isDoitEmployee } = useAuthContext({ mustHaveUser: true });
  const { userRoles } = useUserContext({ requiredRoles: true });

  const canManageLabels = isDoitEmployee || userRoles.cloudAnalyticsAdmin;
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleManageLabelsClick = () => {
    history.push(`${location.pathname}/labels`);
    handleClose();
  };

  return (
    <>
      <Button variant="text" onClick={handleClick} endIcon={<ArrowDropDownIcon />} data-cy="edit-labels-menu-button">
        Edit Labels
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <AssignLabelsButton
          variant="menuItem"
          labels={labels}
          selectedResources={selectedResources}
          disabled={disabled}
          onClose={handleClose}
        />
        <Tooltip title={!canManageLabels ? "You do not have permissions to manage labels" : ""} placement="right">
          <span>
            <MenuItem onClick={handleManageLabelsClick} data-cy="manage-labels-button" disabled={!canManageLabels}>
              Manage labels
            </MenuItem>
          </span>
        </Tooltip>
      </Menu>
    </>
  );
}
